import LocalStorage from '../LocalStorage';
import Outcome, { OUTCOME_IDS } from './Outcome';
import { buildRevenueOutcome } from './utils';

const OUTCOME_CACHE_KEY_PREFIX = "ONESIGNAL_SHOPIFY_OUTCOME";
type SHOPIFY_OUTCOME_KEYS_MAP = {
  [key in OUTCOME_IDS]: string;
}
const KEYS_MAP: SHOPIFY_OUTCOME_KEYS_MAP = {
  os__shopify_revenue: `${OUTCOME_CACHE_KEY_PREFIX}_CART_TOTAL`,
};

export default class Outcomes {
  /**
   * Returns an outcome object for the potential reveue.
   */
  public static getRevenueOutcome(): Outcome {
    return buildRevenueOutcome(this.getRevenueValue());
  }

  /**
   * Stores the value in local storage.
   * 
   * @param value the potential revenue value.
   */
  public static setRevenueValue(value: number): void {
    LocalStorage.set(KEYS_MAP.os__shopify_revenue, `${value}`);
  }

  /**
   * Gets the current value from local storage.  Returns 0 by default.
   */
  public static getRevenueValue(): number {
    const value = LocalStorage.get(KEYS_MAP.os__shopify_revenue);
    if (!value || value.toString().length === 0) {
      return 0;
    }
    return parseInt(value, 10);
  }
}
